<template>
    <div>
        <ul>
            <li v-for='(item, index) of detail.toHistory' :key='index'>
                <dl>
                    <dt>
                        <img :src="imgUrl" alt="">
                    </dt>
                    <dd>
                        <p>{{item.action}}</p>



                        <p v-if='item.action !== "新增"'>

                            [ {{item.action}}:<span>{{item.toUser.name}}</span> ]
                        </p>

                        <p>
                            <span>{{item.createUser.name}} ( {{item.createUser.userid}} )</span>
                            &nbsp;&nbsp; {{item.updateTime}}
                        </p>

                    </dd>
                </dl>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props:{
        detail: Object
    },
    data() {
        return {
            imgUrl: require('../../assets/user.png')
        }
    },
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    ul>li>dl {
        width: 100%;
        display: flex;
        border-bottom: 1px dashed #000;
    }
    ul>li>dl>dt {
        width: 60px;
        padding-top: 10px;
        text-align: center;
    }
</style>
